<template>
  <div class="category-groups-details">
        <v-card>
            <v-card-actions class="shade ma-0 pa-0">
              <v-spacer></v-spacer>
              <v-btn
                data-cy="apply-btn"
                small
                text
                color="blue"
                :disabled="!valid"
                class="text-capitalize"
                @click="apply()">
                Apply
              </v-btn>
              <v-btn
                data-cy="cancel-btn"
                small
                text
                color="blue"
                class="text-capitalize"
                @click="cancel()">
                Cancel
              </v-btn>
            </v-card-actions>
          <v-card-title>
            Category Groups
          </v-card-title>

              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    data-cy="name-text-field"
                    ref="categoryGroups"
                    v-model="name"
                    :rules="[() => !!name || 'Name is required']"
                    label="Category Group"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-text-field
                    data-cy="desc-text-field"
                    ref="description"
                    v-model="description"
                    label="Description"
                    class="ma-1"
                  >
                  </v-text-field>
                  <v-autocomplete
                    data-cy="category-text-field"
                    ref="categoryList"
                    v-model="categoryList"
                    :items="items"
                    item-text="name"
                    item-value="id"
                    attach
                    chips
                    deletable-chips
                    hide-selected
                    multiple
                    label="Categories"
                  >
                 </v-autocomplete>

                </v-form>
              </v-card-text>
              <v-card-actions>
            <v-container>
              <v-row dense>
                <v-btn
                  data-cy="submit-form"
                  color="primary"
                  :disabled="!valid"
                  text
                  @click="apply">Submit</v-btn>
              </v-row>
            </v-container>
              </v-card-actions>

        </v-card>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiDelete } from '@mdi/js'
import { clone } from 'lodash';

export default {
  name: 'CategoryGroupsDetails',
  components: {
  },
  data: () => {
    return {
      svgPath: mdiDelete,
      valid: false,
      formHasErrors: false,
      name: null,
      description: null,
      categoryList: null,
      id: null,
      numberRule: v  => {
        if (!v) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 999) return true;
        return 'Number has to be between 0 and 999';
      },
    }
  },
  beforeCreate() {},

  created() {
    this.$store.dispatch('getCategoryList');
    if (this.categoryGroups) {
      this.name = clone(this.categoryGroups.name)
      this.description = clone(this.categoryGroups.description)
      this.categoryList = clone(this.categoryGroups.categoryList)
      this.id = clone(this.categoryGroups.id)
    }
  },

  mounted() {
   },

  beforeDestroy() {
  },

  computed: {
    ...mapGetters({
      categoryGroups: 'getSelectedCategoryGroups',
      items: 'getCategoryList',
    }),
  },

  methods: {
    cancel () {
      this.$router.push({name: 'CategoryGroups' })
    },
    apply () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('applyCategoryGroupsDetails', {id: this.id, name: this.name, description: this.description, categoryList: this.categoryList});
        this.$router.push({name: 'CategoryGroups' })
      }
    }
  },


}
</script>

<style lang="scss" scoped>
.category-groups-details {

}
</style>
